import React, { useState } from 'react';
import FeatherIcon from 'feather-icons-react';

const SearchInput = ({
  value,
  defaultValue = '',
  onValueChange,
  onSearch,
  onPageReset,
  onClear,
  placeholder,
  showClear,
}) => {
  const [innerValue, setInnerValue] = useState(defaultValue);
  const resolvedValue = value !== undefined ? value : innerValue;
  const hasValue = !!String(resolvedValue).trim();
  const shouldShowClear = typeof showClear === 'boolean' ? showClear : hasValue;

  const emitChange = (nextValue) => {
    if (value === undefined) {
      setInnerValue(nextValue);
    }
    if (onValueChange) {
      onValueChange(nextValue);
    }
    if (onSearch) {
      onSearch({ target: { value: nextValue } });
    }
    if (onPageReset) {
      onPageReset();
    }
  };

  const handleChange = (e) => {
    emitChange(e.target.value);
  };

  const handleClear = () => {
    emitChange('');
    if (onClear) {
      onClear();
    }
  };

  return (
    <span className='sa-table-btn-mute sa-search-align sa-table-float-left sa-participant-search'>
      <input
        className='sa-table-search sa-table-search-point font-14'
        onChange={handleChange}
        value={resolvedValue}
        type="text"
        placeholder={placeholder}
      />
      {shouldShowClear && (
        <button
          type="button"
          className="search-clear-btn"
          onClick={handleClear}
          title='Clear'
        >
          <FeatherIcon icon="x" width="16px" />
        </button>
      )}
      <FeatherIcon className="sa-search-icon" icon="search" width="16px" />
    </span>
  );
};

export default SearchInput;
